import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

const Portal = lazy(() => import('@/pages/portal/Portal'));
const Test = lazy(() => import('@/pages/portal/test'));

const portalRoutes: RouteObject[] = [
  {
    path: '/portal',
    element: <Portal />
  },
  {
    path: '/test',
    element: <Test />
  }
];

export default portalRoutes;
